<template>
  <div class="news">
    <section class="wf100 subheader" style="background: var(--secondary)">
      <div class="container">
        <h2>أخبار المنظمة</h2>
        <ul>
          <li><router-link to="/" href="#">الرئيسية</router-link></li>
          <li><a href="#"> المنظمة </a></li>
          <li>الأخبار</li>
        </ul>
      </div>
    </section>

    <!--Sub Header End-->
    <!--Main Content Start-->
    <div class="main-content mt-2">
      <!--Events Start-->
      <div class="events-wrapper">
        <div class="container">
          <div v-if="loading" class="row">
            <div
              v-for="n in 3"
              :key="n"
              class="col-lg-4 col-md-6 col-12 p-1 justify-center-center"
            >
              <skeleton> </skeleton>
            </div>
          </div>
          <div v-else class="row">
            <!--Event Start-->
            <div v-for="item in news" :key="item.id" class="col-md-4 col-sm-6">
              <div class="event-post mt-2">
                <img
                  :src="item.image"
                  alt="news-img"
                  width="100%"
                  style="max-height: 255px; object-fit: cover"
                />
                <div class="event-post-content">
                  <div class="event-post-txt">
                    <h5>
                      <router-link
                        :to="{
                          name: 'activity',
                          params: { id: $route.params.id, activityId: item.id },
                        }"
                        >{{ item.title_ar }}</router-link
                      >
                    </h5>
                    <!--<ul class="event-meta">-->
                    <!--<li>-->
                    <!--<feather-icon icon="ClockIcon" size="15" />-->
                    <!--{{ item.accomplished_at }}-->
                    <!--</li>-->
                    <!--</ul>-->
                    <p>{{ item.description_ar.substring(0, 80) }}...</p>
                  </div>
                  <div class="event-post-loc">
                    <feather-icon
                      icon="MapPinIcon"
                      color="#048042db"
                      size="15"
                    />
                    {{ item.governorate.name_ar }}
                    <router-link
                      :to="{
                        name: 'activity',
                        params: { id: $route.params.id, activityId: item.id },
                      }"
                      ><feather-icon
                        color="white"
                        icon="ChevronLeftIcon"
                        size="15"
                    /></router-link>
                  </div>
                </div>
              </div>
            </div>
            <alert
              v-if="news.length == 0 && !loading"
              class="w-100 mb-5"
              :massage="$t('alert')"
            >
            </alert>
            <!--Event End-->
          </div>

          <pagination
            v-model="currentPage"
            :total-rows="pagination.total_row"
            :per-page="pagination.per_page"
            align="center"
            class="mt-2 mb-2"
          >
          </pagination>
        </div>
      </div>
      <!--Events End-->
    </div>
    <!--Main Content End-->
  </div>
</template>

<script>
import Slider from "../../components/Slider";
import NgoHeader from "../../components/NgoHeader.vue";
import { mapGetters } from "vuex";
import Pagination from "@/components/pagination";
import Skeleton from "../../components/Skeleton.vue";
import Alert from "@/components/Alert.vue";

import {
  BNav,
  BNavItem,
  BFormGroup,
  BInputGroupPrepend,
  BInputGroup,
  BFormInput,
  BPagination,
} from "bootstrap-vue";
export default {
  components: {
    Slider,
    NgoHeader,
    BNav,
    BNavItem,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
    BPagination,
    Pagination,
    Skeleton,
    Alert,
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  watch: {
    currentPage(value) {
      this.$store.dispatch("NgoHome/newsNgo/getNews", {
        page: value,
        id: this.$route.params.id,
      });
    },
  },
  methods: {
    // subLength(setring){
    //   return setring.substring
    // }
  },
  computed: {
    ...mapGetters("NgoHome/newsNgo", ["news", "loading", "pagination"]),
  },
  created() {
    this.$store.dispatch("NgoHome/newsNgo/getNews", {
      page: this.currentPage,
      id: this.$route.params.id,
    });
  },
};
</script>

<style lang="scss">
.news {
  .h3-logo-row .h3-logo {
    padding: 2px !important;
  }
  .event-post {
    .thumb {
      img {
        height: 200px;
      }
    }
  }
  .event-post-txt {
    p,
    ul li {
      color: #048042db;
    }
  }
  .event-post-loc {
    color: #048042db;
  }
}
</style>
